import { lazy } from 'react';
import { Route } from 'react-router-dom';
import PublicPageShell from '../shared/Public/PublicPageShell';

const ProductLanding = lazy(() => import('../shared/Public/ProductLanding'));
const ProductContact = lazy(() => import('../shared/Public/ProductContact'));
const About = lazy(() => import('../shared/About/About'));
const Privacy = lazy(() => import('../shared/Privacy/Privacy'));
const LoginForm = lazy(() => import('../shared/Login/LoginForm'));
const VerifyEmail = lazy(() => import('../shared/Login/VerifyEmail'));
const LeadCaptureForm = lazy(() => import('../modules/Public/LeadCaptureForm'));
const PartnerJoin = lazy(() => import('../modules/Public/PartnerJoin'));
const SubscriptionInactive = lazy(() => import('../shared/SubscriptionInactive/SubscriptionInactive'));
const MetaOAuthCallback = lazy(() => import('../modules/SuperAdmin/components/MetaOAuthCallback'));

export const publicRoutes = (
  <>
    <Route path="/login" element={<LoginForm />} />
    <Route path="/verify-email" element={<VerifyEmail />} />
    <Route path="/meta-oauth-callback" element={<MetaOAuthCallback />} />
    <Route path="/subscription-inactive" element={<SubscriptionInactive />} />
    <Route path="/" element={<ProductLanding />} />
    <Route path="/home" element={<ProductLanding />} />
    <Route path="/contact-sales" element={<ProductContact />} />
    <Route path="/about" element={<PublicPageShell><About /></PublicPageShell>} />
    <Route path="/privacy" element={<PublicPageShell><Privacy /></PublicPageShell>} />
    <Route path="/lead-form/:clientId" element={<LeadCaptureForm />} />
    <Route path="/lead-form" element={<LeadCaptureForm />} />
    <Route path="/partner/join/:clientId" element={<PartnerJoin />} />
  </>
);
